







































import {
  Component, Vue,
} from 'vue-property-decorator';

import PageHeader from '@/components/PageHeader/PageHeader.vue';
import Footer from '@/components/Footer/Footer.vue';

import WarningPaymentPendency from './components/WarningPaymentPendency/WarningPaymentPendency.vue';
import PlanTypes from './components/PlanTypes/index.vue';
import Banner from './components/Banner/Banner.vue';
import ContainerPlans from './components/ContainerPlans/ContainerPlans.vue';
import ModalDescriptionsPlan from './components/ModalDescriptionsPlan/ModalDescriptionsPlan.vue';

import PaymentService from '@/services/Payment/PaymentService';

const PAYMENT_STATUS_PENDING = 'pending';

@Component({
  components: {
    PageHeader,
    Footer,
    WarningPaymentPendency,
    Banner,
    PlanTypes,
    ContainerPlans,
    ModalDescriptionsPlan,
  },
})
export default class Shopping extends Vue {
  private isPendency = false;

  private PaymentService = new PaymentService();

  created() {
    this.getPendency();
  }

  mounted() {
    this.setBreadCrumbs();
  }

  get isMobile() {
    return this.$responsive.isMobile;
  }

  async getPendency() {
    try {
      const response = await this.PaymentService.getPayment({
        statusExternal: PAYMENT_STATUS_PENDING,
      });

      this.isPendency = !!response.length;
    } catch (error) {
      this.isPendency = false;

      console.error(error);
    }
  }

  get planIdSelected() {
    return this.$store.getters?.activeDescriptiveModal?.id;
  }

  get planTitleSelected() {
    return this.$store.getters?.activeDescriptiveModal?.title;
  }

  handleClickPendency() {
    this.$router.push({
      name: 'Pendencies',
    });
  }

  setBreadCrumbs() {
    this.$breadcrumb.set([
      { title: 'Loja', to: null },
    ]);
  }
}
